"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModuleEnablementContext = exports.ModuleEnablementProvider = exports.ModuleEnablementContext = void 0;
exports.withModuleEnablement = withModuleEnablement;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _AppStateContext = require("./AppStateContext");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var createModuleEnablementContext = function createModuleEnablementContext(_ref) {
  var modules = _ref.modules,
      enabledEntities = _ref.enabledEntities;
  return {
    modules: modules,
    enabledEntities: enabledEntities,
    isModuleEnabled: function isModuleEnabled(moduleName) {
      return modules.includes(moduleName);
    },
    isEntityEnabled: function isEntityEnabled(entityName) {
      var _enabledEntities$enti;

      return (_enabledEntities$enti = enabledEntities[entityName]) !== null && _enabledEntities$enti !== void 0 ? _enabledEntities$enti : false;
    }
  };
};

exports.createModuleEnablementContext = createModuleEnablementContext;
var defaultContext = createModuleEnablementContext({
  modules: [],
  enabledEntities: {}
});
var ModuleEnablementContext = (0, _preactCompat.createContext)(defaultContext);
exports.ModuleEnablementContext = ModuleEnablementContext;

var ModuleEnablementProvider = function ModuleEnablementProvider(_ref2) {
  var children = _ref2.children;
  return (0, _preact.h)(_AppStateContext.AppStateContext.Consumer, null, function (appState) {
    var moduleEnablementContextValue = createModuleEnablementContext({
      modules: appState.activeHubModules,
      enabledEntities: appState.activeEntities
    });
    return (0, _preact.h)(ModuleEnablementContext.Provider, {
      value: moduleEnablementContextValue
    }, children);
  });
};

exports.ModuleEnablementProvider = ModuleEnablementProvider;

function withModuleEnablement(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithModuleEnablementWrapper, _Component);

    var _super = _createSuper(WithModuleEnablementWrapper);

    function WithModuleEnablementWrapper() {
      (0, _classCallCheck2.default)(this, WithModuleEnablementWrapper);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(WithModuleEnablementWrapper, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return (0, _preact.h)(ModuleEnablementContext.Consumer, null, function (moduleEnablementContextValue) {
          return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, props, moduleEnablementContextValue));
        });
      }
    }]);
    return WithModuleEnablementWrapper;
  }(_preact.Component);
}